import * as React from 'react'
import { DisplayContent } from 'react-content-engine'

import { UI } from 'components/_Assets/svg/Icon/ui'
import Icon from 'components/Icon'

interface CodeEntryCardProps {
  code: string
  currency: string
  amount: number
  message?: React.ReactNode
  onClickDelete?: (code: string) => void
}

const CodeEntryCard: React.FC<CodeEntryCardProps> = props => {
  return (
    <li>
      <DisplayContent contentKey="gift-card-value">
        Gift card value
      </DisplayContent>
      {props.currency} {props.amount}
      {props.message ? (
        <>
          <br />
          <em>{props.message}</em>
        </>
      ) : (
        ''
      )}
      <button
        onClick={() =>
          props.onClickDelete ? props.onClickDelete(props.code) : null
        }
      >
        <Icon icon={UI.trash} />
      </button>
    </li>
  )
}

export default CodeEntryCard
